import React from "react";
import { Globe, Check } from "lucide-react";
import { useT } from "../i18n/LanguageContext";
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
} from "./ui/dropdown-menu";

export const LanguageSwitcher = ({ variant = "dark" }) => {
  const { lang, setLang, langs } = useT();
  const current = langs.find((l) => l.code === lang);

  const triggerColor =
    variant === "light"
      ? "text-white hover:text-[#1093f0]"
      : "text-[#3f444b] hover:text-[#1f2226]";

  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        data-testid="lang-switcher-trigger"
        className={`inline-flex items-center gap-1.5 text-sm font-medium px-3 py-2 rounded-full hover:bg-black/5 transition-colors ${triggerColor}`}
        aria-label="Language"
      >
        <Globe className="w-4 h-4" />
        <span className="mono">{current?.short || "FR"}</span>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="min-w-[180px]" data-testid="lang-switcher-menu">
        <DropdownMenuLabel className="text-xs uppercase tracking-wider text-[#6b7079]">
          Language
        </DropdownMenuLabel>
        <DropdownMenuSeparator />
        {langs.map((l) => (
          <DropdownMenuItem
            key={l.code}
            onClick={() => setLang(l.code)}
            data-testid={`lang-option-${l.code}`}
            className="cursor-pointer flex items-center justify-between"
          >
            <span className="flex items-center gap-2.5">
              <span className="mono text-xs text-[#6b7079] w-6">{l.short}</span>
              {l.label}
            </span>
            {lang === l.code && <Check className="w-4 h-4 text-[#1093f0]" />}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default LanguageSwitcher;
